module.exports = __webpack_public_path__ + "static/media/logo-light-fr.be8a4029.svg";